import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import parse from 'html-react-parser';
import './css/GameInformation1.css';
import { useHistory } from 'react-router-dom';
import { context } from '../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { getHTMLTextFromNormalText, getWebsiteImage } from '../../../../catalog/Website';
import { getFullDateStringFromDate, getDateTimeStringFromDate, getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import ShareComponent1 from '../../../uiElements/shareComponents/shareComponent1/ShareComponent1';
import { getGameShareTitle, getGameURL } from '../../../../catalog/Social';
import { sendCustomAnalytics } from '../../../../catalog/Analytics';
import Button1 from '../../../uiElements/buttons/Button1';

const GameInformation1 = (props) => {
    const { id, title, featureImage, promotionalText, promotionalVideo, venue, status, timeOfGame, opponentName, showTickets } = props;
    const history = useHistory();
    const { globalState } = useContext(context);

    const getImage = () => {
        if (isValidString(featureImage)) {
            return featureImage;
        } if (isValidObject(getWebsiteImage(globalState, 'gameFeatureImage'))) {
            return getWebsiteImage(globalState, 'gameFeatureImage');
        }
        return '';
    };

    const getTitle = () => {
        if (isValidString(venue) || status !== 'tba' || isValidString(opponentName)) {
            let str = 'Game';

            if (isValidString(opponentName)) {
                str += ` against ${opponentName}`;
            }

            if (isValidString(venue)) {
                str += ` at ${venue}`;
            }

            if (status === 'tba') {
                str += '';
            } else if (status === 'tbat') {
                str += ` on ${getFullDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfGame))}`;
            } else {
                str += ` on ${getDateTimeStringFromDate(getLocalTimeFromDatabaseTime(timeOfGame))}`;
            }

            return str;
        }
        return title;
    };

    return (
        <div className="game-info1-container-container">
            <div className="game-info1-container x-center p-t-20px p-b-20px p-l-50px p-r-50px m-t-50px m-b-50px">
                <p className="game-info1-title font-spacing-wide line-height-wider text-center-align m-t-0 m-b-10px text-uppercase font-size-2xl font-weight-800">{getTitle()}</p>
                <ShareComponent1
                    title="Game"
                    image={getImage()}
                    url={getGameURL(globalState, id)}
                    shareTitle={getGameShareTitle(title, globalState.teamAlias, status, venue, timeOfGame, opponentName)}
                    center
                    marginTop={20}
                    marginBottom={20}
                    marginLeft={0}
                    mobileMarginTop={20}
                    mobileMarginBottom={20}
                    mobileMarginLeft={0}
                />
                {showTickets ? (
                    <div className="m-b-20px">
                        <Button1
                            title="Buy Tickets"
                            // showSilhouetteLogo
                            backgroundColor={globalState.websiteStyles.colors.primaryColor}
                            fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                            borderColor="#ffffff"
                            fontSize="0.9rem"
                            borderRadius="5px"
                            width="200px"
                            height="44px"
                            onClick={() => { history.push(`/games/${id}/tickets`); }}
                        />
                    </div>
                ) : null}
                <img className="game-info1-image curve-border-10px full-width m-b-50px" src={getImage()} alt="Game Feature" />
                {isValidObject(promotionalVideo) && isValidString(promotionalVideo.url) ? (
                    <div className="game-info1-video">
                        {isValidString(promotionalVideo.title)
                            ? <p className="game-info1-title font-spacing-wide line-height-wider text-center-align m-t-0 m-b-10px text-uppercase font-size-2xl font-weight-800">{promotionalVideo.title}</p>
                            : <p className="game-info1-title font-spacing-wide line-height-wider text-center-align m-t-0 m-b-10px text-uppercase font-size-2xl font-weight-800">Game Video/Live Streaming</p>}
                        <div className="game-info1-video-player-container">
                            <ReactPlayer
                                className="game-info1-video-player"
                                url={promotionalVideo.url}
                                controls
                                width="100%"
                                height="100%"
                                config={{
                                    facebook: {
                                        attributes: {
                                            height: '360px',
                                            padding: '0',
                                            backgroundColor: '#000',
                                        },
                                    },
                                }}
                                onStart={() => { sendCustomAnalytics('game_video', { videoControl: 'start' }); }}
                                onEnded={() => { sendCustomAnalytics('game_video', { videoControl: 'ended' }); }}
                            />
                        </div>
                    </div>
                ) : null}
                <div className="game-info1-content alegreya-font-family game-info1-text font-spacing-wider line-height-wider text-left-align m-t-50px m-b-50px font-size-l">
                    {parse(getHTMLTextFromNormalText(promotionalText))}
                </div>
                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                    <img src={globalState.logo.logo2} className="game-info1-icon" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                ) : null}
            </div>
        </div>
    );
};

GameInformation1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    featureImage: PropTypes.string.isRequired,
    promotionalText: PropTypes.string.isRequired,
    promotionalVideo: PropTypes.object.isRequired,
    venue: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    timeOfGame: PropTypes.object.isRequired,
    opponentName: PropTypes.string.isRequired,
    showTickets: PropTypes.bool.isRequired,
};

export default memo(GameInformation1);
